import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./Header.module.css";
import logo from "../../images/wyr-logo.png";

function Header() {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const user = localStorage.getItem("user");

  let userData = null;
  try {
    userData = user ? JSON.parse(user) : null;
  } catch (error) {
    console.error("Error parsing user data:", error);
    localStorage.removeItem("user");
  }

  const logoutUser = (e) => {
    e.preventDefault();
    localStorage.removeItem("user");
    navigate("/");
    window.location.reload();
  };

  const toggleMobileMenu = (e) => {
    e.stopPropagation();
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isMobileMenuOpen &&
        !event.target.closest(`.${styles.navbar}`) &&
        !event.target.closest(`.${styles.mobile_sidebar}`)
      ) {
        closeMobileMenu();
      }
    };

    if (isMobileMenuOpen) {
      const timeoutId = setTimeout(() => {
        document.addEventListener("click", handleClickOutside);
      }, 100);

      return () => {
        clearTimeout(timeoutId);
        document.removeEventListener("click", handleClickOutside);
      };
    }

    return () => document.removeEventListener("click", handleClickOutside);
  }, [isMobileMenuOpen]);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isMobileMenuOpen]);

  return (
    <>
      <nav className={styles.navbar}>
        <Link to="/" onClick={closeMobileMenu}>
          <img className={styles.logo} src={logo} alt="WYR Logo" />
        </Link>

        <div className={styles.nav_right}>
          <div className={styles.desktop_nav}>
            <Link className={styles.navcontent} to="/blog">
              Blogs
            </Link>
            <Link className={styles.navcontent} to="/category">
              Categories
            </Link>
            {userData?.access ? (
              <>
                <Link to="/profile" className={styles.navcontent}>
                  Profile
                </Link>
                <Link className={styles.navcontent} to="/" onClick={logoutUser}>
                  Sign Out
                </Link>
              </>
            ) : (
              <Link className={styles.navcontent} to="/login">
                Sign In
              </Link>
            )}
          </div>

          <button
            className={`${styles.hamburger} ${
              isMobileMenuOpen ? styles.hamburger_active : ""
            }`}
            onClick={toggleMobileMenu}
            onMouseDown={(e) => e.preventDefault()}
            aria-label="Toggle mobile menu"
            aria-expanded={isMobileMenuOpen}
            type="button"
          >
            <span className={styles.hamburger_line}></span>
            <span className={styles.hamburger_line}></span>
            <span className={styles.hamburger_line}></span>
          </button>
        </div>
      </nav>

      <div
        className={`${styles.mobile_sidebar} ${
          isMobileMenuOpen ? styles.mobile_sidebar_open : ""
        }`}
      >
        <div className={styles.mobile_nav}>
          <Link
            className={styles.mobile_navcontent}
            to="/blog"
            onClick={closeMobileMenu}
          >
            Blogs
          </Link>
          <Link
            className={styles.mobile_navcontent}
            to="/category"
            onClick={closeMobileMenu}
          >
            Categories
          </Link>
          {userData?.access ? (
            <>
              <Link
                to="/profile"
                className={styles.mobile_navcontent}
                onClick={closeMobileMenu}
              >
                Profile
              </Link>
              <Link
                className={styles.mobile_navcontent}
                to="/"
                onClick={(e) => {
                  closeMobileMenu();
                  logoutUser(e);
                }}
              >
                Sign Out
              </Link>
            </>
          ) : (
            <Link
              className={styles.mobile_navcontent}
              to="/login"
              onClick={closeMobileMenu}
            >
              Sign In
            </Link>
          )}
        </div>
      </div>

      {isMobileMenuOpen && (
        <div
          className={`${styles.overlay} ${styles.overlay_visible}`}
          onClick={closeMobileMenu}
        ></div>
      )}
    </>
  );
}

export default Header;
